import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const handleCustomize = () => {
    setShowDetails(!showDetails);
  };

  const handleClose = () => {
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Cookie Banner - Smaller and less visible */}
      <div className="fixed bottom-4 right-4 z-50 max-w-sm transform transition-transform duration-300">
        <div className="bg-white border border-gray-200 rounded-lg shadow-md p-4">
          {/* Header */}
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center">
              <Cookie className="w-4 h-4 text-orange-500 mr-2 flex-shrink-0" />
              <h3 className="text-sm font-medium text-gray-900">
                Cookie Notice
              </h3>
            </div>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 transition-colors p-1"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          {/* Content */}
          <div className="mb-4">
            <p className="text-gray-600 text-xs leading-relaxed mb-2">
              We use cookies to enhance your experience and analyze site traffic.
            </p>
            
            {showDetails && (
              <div className="bg-gray-50 rounded-md p-3 mt-3 space-y-2">
                <div className="text-xs">
                  <div className="mb-2">
                    <span className="font-medium text-gray-900">🔒 Essential:</span>
                    <span className="text-gray-600 ml-1">Required for functionality</span>
                  </div>
                  <div className="mb-2">
                    <span className="font-medium text-gray-900">📊 Analytics:</span>
                    <span className="text-gray-600 ml-1">Help us improve our site</span>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Actions */}
          <div className="flex flex-col gap-2">
            <div className="flex gap-2">
              <button
                onClick={handleAcceptAll}
                className="bg-orange-500 hover:bg-orange-600 text-white text-xs font-medium py-2 px-3 rounded transition-colors flex-1"
              >
                Accept All
              </button>
              
              <button
                onClick={handleAcceptNecessary}
                className="bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs font-medium py-2 px-3 rounded transition-colors flex-1"
              >
                Essential Only
              </button>
            </div>
            
            <div className="text-center">
              <button
                onClick={handleCustomize}
                className="text-xs text-gray-500 hover:text-gray-700 transition-colors"
              >
                {showDetails ? 'Hide Details' : 'More Info'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookieConsent;